import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCol,
  IonRow,
  IonSearchbar,
  IonText,
} from "@ionic/react";

import { useEffect, useState } from "react";
import { getDate } from "../../genericFunctions/date";
import { makeGETRequest, makePOSTRequest } from "../../request/rawRequest";
import { getCurrentTechnoOrDisconnect } from "../../variables/jobDictionnary";
import BasicPage from "../BasicPage/BasicPage";
import "../generalCSS/stylesheet.css";
import "./Replay.css";

const getSubject = (subject: string) => {
  switch (subject) {
    case "pat":
      return "Pâtisserie";
    case "boul":
      return "Boulangerie";
    case "char":
      return "Charcuterie";
  }
};

const NextLivesDisplay: React.FC<any> = (replayList: any[]) => {
  const urlParam = new URLSearchParams(window.location.search);
  const [searchText, setSearchText] = useState<string>("");
  const [replaySearch, setReplaySearch] = useState<any[]>(replayList);

  useEffect(() => {
    if (searchText.length <= 0) {
      setReplaySearch(replayList);
    } else {
      setReplaySearch(
        replayList.filter((r: any) =>
          r.name
            .toLowerCase()
            .replaceAll(" ", "")
            .includes(searchText.toLowerCase().replaceAll(" ", ""))
        )
      );
    }
  }, [searchText]);

  useEffect(() => {
    setReplaySearch(replayList);
  }, [replayList]);

  return (
    <IonRow>
      <IonCol className="border-radius">
        <IonRow>
          <IonCol className="ion-justify-content-center">
            <IonSearchbar
              value={searchText}
              onIonChange={(e) => {
                setSearchText(e.detail.value!);
              }}
              animated
              placeholder="Recherche d'un replay"
            ></IonSearchbar>
          </IonCol>
        </IonRow>
        {replaySearch.length === 0 && (
          <IonRow>
            <IonCol className="ion-justify-content-center flex">
              <IonText color="black">Aucun replay n'a ce titre</IonText>
            </IonCol>
          </IonRow>
        )}
        {replaySearch.map((replay, i) => {
          const idVideo = replay.link
            ? replay.link.split("/")[replay.link.split("/").length - 1]
            : "";
          const date = replay.date ? getDate(replay.date.toString()) : "";
          return (
            <IonCard
              key={i}
              color="light"
              className="card border-radius card-live border-primary-contrast"
              href={
                "auth/videoreplay?" +
                "&type=" +
                (urlParam.get("type") ?? "") +
                "&id=" +
                replay._id +
                (replay.replay ? "&link=" + replay.replay : "")
              }
            >
              <IonCardContent>
                {replay.link && (
                  <IonRow className="ion-justify-content-center">
                    <IonCol className="ion-justify-content-center flex">
                      <img
                        alt="image du live"
                        className="border-radius"
                        src={
                          "https://img.youtube.com/vi/" +
                          idVideo +
                          "/hqdefault.jpg"
                        }
                      ></img>
                    </IonCol>
                  </IonRow>
                )}
                <IonRow>
                  <p className="live-title black-text bold">{replay.name}</p>
                </IonRow>
                <IonRow>
                  <p className="live-title black-text bold">
                    {replay.host ? "par " + replay.host : ""}
                  </p>
                </IonRow>
                {date && (
                  <IonRow>
                    <p className="live-title">Le live a eu lieu le {date}</p>
                  </IonRow>
                )}
                <IonRow>
                  <p className="live-title black-text ">
                    {getSubject(replay.subject)}
                  </p>
                </IonRow>
                <IonRow className="ion-justify-content-center">
                  <IonCol size="12" size-lg="6" size-sm="12">
                    <IonText>
                      <p className="bold hover-underline btn">
                        Voir le replay !
                      </p>
                    </IonText>
                  </IonCol>
                </IonRow>
              </IonCardContent>
            </IonCard>
          );
        })}
      </IonCol>
    </IonRow>
  );
};

interface ContainerProps {}

function compare(a: any, b: any): number {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
}

const Replay: React.FC<ContainerProps> = () => {
  const [replay, setReplay] = useState<any[]>([]);
  const url = new URLSearchParams(window.location.search);

  const addPoleThemes = async () => {
    ["0", "1", "2"].forEach(async (index) => {
      const themes: any[] = [];
      const videos: any[] = [];

      await makeGETRequest(
        "/skills/technology/unique?pole=" +
          index +
          "&type=" +
          getCurrentTechnoOrDisconnect()
      ).then((res) => {
        for (const theme of res) {
          themes.push(...theme.id_themes);
        }
      });

      await makePOSTRequest("/themes", { _id: themes }).then((res) => {
        for (const video of res) {
          videos.push(...video.id_videos);
        }
      });

      for (const videoID of videos) {
        makeGETRequest("/video/replay?_id=" + videoID).then((res) => {
          if (typeof res !== "string" && res.replay && res.replay.length > 1) {
            setReplay((old) => [...old, res]);
          }
        });
      }
    });
  };

  const getReplaysPratique = async () => {
    await makeGETRequest(
      "/event/subject?type=replay&subject=" + getCurrentTechnoOrDisconnect()
    ).then((response: any[]) => {
      response = response.map((replay) => ({ ...replay, name: replay.title }));
      setReplay(response);
    });
  };

  const getReplaysTechno = async () => {
    await addPoleThemes();
  };

  useEffect(() => {
    switch (url.get("type")) {
      case "pratique":
        getReplaysPratique();
        break;
      case "techno":
        getReplaysTechno();
        break;

      default:
        break;
    }
  }, []);

  return (
    <BasicPage pathReturn title="Replay" subtitle="">
      <IonRow className="ion-justify-content-end">
        <IonButton
          shape="round"
          fill="solid"
          color="secondary"
          strong
          onClick={() => {
            window.location.href =
              window.location.origin +
              window.location.pathname +
              "?type=" +
              (url.get("type") === "pratique" ? "techno" : "pratique");
          }}
        >
          Replay {url.get("type") === "pratique" ? "Technologie" : "Pratique"}
        </IonButton>
      </IonRow>
      {NextLivesDisplay(replay)}
    </BasicPage>
  );
};

export default Replay;
